const state = {
  roleCompetencyOptions: [],
  competencyOptions: [],
  loadingRoleCompetency: false,
  loadingCompetency: false,
  error: null
};

const mutations = {
  SET_ROLE_COMPETENCY_OPTIONS(state, options) {
    state.roleCompetencyOptions = options;
  },
  SET_COMPETENCY_OPTIONS(state, options) {
    state.competencyOptions = options;
  },
  SET_LOADING_ROLE_COMPETENCY(state, status) {
    state.loadingRoleCompetency = status;
  },
  SET_LOADING_COMPETENCY(state, status) {
    state.loadingCompetency = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  }
};

const actions = {
  async loadRoleCompetencyOptions({ commit }) {
    commit('SET_LOADING_ROLE_COMPETENCY', true);
    commit('CLEAR_ERROR');

    try {
      const { GET_ROLE_COMPETENCIES } = await import('@/api/master-data/role-competency/role-competency');
      const response = await GET_ROLE_COMPETENCIES('page=1&limit=100');
      
      if (response.data && response.data.httpCode === 200) {
        const roleData = response.data.data.data || response.data.data;
        const transformedOptions = roleData.map(item => ({
          value: item.id,
          label: item.role_competency_name || item.name
        }));
        
        commit('SET_ROLE_COMPETENCY_OPTIONS', transformedOptions);
      }
    } catch (error) {
      console.error('Error loading role competency options:', error);
      commit('SET_ERROR', error.message || 'Failed to load role competency options');
    } finally {
      commit('SET_LOADING_ROLE_COMPETENCY', false);
    }
  },

  async loadCompetencyOptions({ commit }) {
    commit('SET_LOADING_COMPETENCY', true);
    commit('CLEAR_ERROR');

    try {
      const { GET_COMPETENCIES } = await import('@/api/master-data/competency/competency');
      const response = await GET_COMPETENCIES({ page: 1, limit: 100 });

      if (response.data) {
        const competencyData = response.data.data.data || response.data.data;
        const transformedOptions = competencyData.map(item => ({
          value: item.id,
          label: item.competency_name || item.name
        }));
        
        commit('SET_COMPETENCY_OPTIONS', transformedOptions);
      }
    } catch (error) {
      console.error('Error loading competency options:', error);
      commit('SET_ERROR', error.message || 'Failed to load competency options');
    } finally {
      commit('SET_LOADING_COMPETENCY', false);
    }
  }
};

const getters = {
  getRoleCompetencyOptions: state => state.roleCompetencyOptions,
  getCompetencyOptions: state => state.competencyOptions,
  getLoadingRoleCompetency: state => state.loadingRoleCompetency,
  getLoadingCompetency: state => state.loadingCompetency,
  getError: state => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
